import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { postAPI } from '../../../app/api';
import './Login.css';
import logoMini from '../../../assets/img/logo-mini.png';



export default function Login() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        user_type: 'ADMIN',
        username: '',
        password: ''
    });

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Toggle password visibility
    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    // Handle login
    const handleLogin = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.username.trim()) {
            Swal.fire('Validation Error', 'Please enter email or phone number', 'warning');
            return;
        }
        if (!formData.password.trim()) {
            Swal.fire('Validation Error', 'Please enter password', 'warning');
            return;
        }

        setLoading(true);
        try {
            const response = await postAPI('authentication/users/login', formData);

            if (response?.status === 1) {
                // Store login details in localStorage
                localStorage.setItem('user_code', response?.data?.user_code);
                localStorage.setItem('full_name', response?.data?.full_name);
                localStorage.setItem('email_id', response?.data?.email_id);
                localStorage.setItem('mobile_number', response?.data?.mobile_number);
                localStorage.setItem('user_type', response?.data?.user_type);
                localStorage.setItem('access_token', response?.data?.access_token);

                Swal.fire('Success', 'Login successful!', 'success');

                // Redirect based on user type
                // if (response?.data?.user_type === 'ADMIN') {
                //     navigate('/dashboard');
                // } else if (response?.data?.user_type === 'ALUMNI') {
                //     navigate('/alumni-dashboard');
                // } else {
                //     navigate('/dashboard');
                // }
                window.location.reload();
            } else {
                Swal.fire('Login Failed', response?.msg || 'Invalid credentials', 'error');
            }
        } catch (error) {
            Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Handle forgot password
    const handleForgotPassword = () => {
        navigate('/forgot-password');
    };

    // Handle sign up
    const handleSignUp = () => {
        navigate('/register');
    };

    return (
        <div className="login-container">
            <div className="login-wrapper">
                <div className="login-box">
                    {/* Logo/Header */}
                    <div className="login-header">
                        <h1>B.E College Ex-Students' Club</h1>
                        <p>Alumni Network Management System</p>
                    </div>

                    {/* Login Form */}
                    <form onSubmit={handleLogin} className="login-form">
                        <h2>Welcome Back</h2>
                        <p className="login-subtitle">Sign in to your account</p>

                        {/* Username/Email Input */}
                        <div className="form-group">
                            <label className="form-label">Email or Phone Number *</label>
                            <input
                                type="text"
                                className="form-control"
                                name="username"
                                value={formData.username}
                                onChange={handleInputChange}
                                placeholder="Enter your email or phone number"
                                disabled={loading}
                                required
                            />
                        </div>

                        {/* Password Input */}
                        <div className="form-group">
                            <label className="form-label">Password *</label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="form-control"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    placeholder="Enter your password"
                                    disabled={loading}
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={handleTogglePassword}
                                    disabled={loading}
                                    title={showPassword ? 'Hide password' : 'Show password'}
                                >
                                    {showPassword ? '�' : '👁️'}
                                </button>
                            </div>
                        </div>

                        {/* Remember Me & Forgot Password */}
                        {/* <div className="form-footer">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="rememberMe"
                                    disabled={loading}
                                />
                                <label className="form-check-label" htmlFor="rememberMe">
                                    Remember me
                                </label>
                            </div>
                            <button
                                type="button"
                                className="forgot-password-link"
                                onClick={handleForgotPassword}
                                disabled={loading}
                            >
                                Forgot Password?
                            </button>
                        </div> */}

                        {/* Login Button */}
                        <button
                            type="submit"
                            className="btn btn-login"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Logging in...
                                </>
                            ) : (
                                'Sign In'
                            )}
                        </button>
                    </form>

                    {/* Divider */}
                    {/* <div className="login-divider">
                        <span>Don't have an account?</span>
                    </div> */}

                    {/* Sign Up Button */}
                    {/* <button
                        type="button"
                        className="btn btn-signup"
                        onClick={handleSignUp}
                        disabled={loading}
                    >
                        Create Account
                    </button> */}

                    {/* Footer Links */}
                    <div className="login-footer">
                        <p>
                            <a href="#privacy" onClick={(e) => { e.preventDefault(); }}>Privacy Policy</a>
                            {' '} • {' '}
                            <a href="#terms" onClick={(e) => { e.preventDefault(); }}>Terms of Service</a>
                        </p>
                        <p className="copyright">© 2025 B.E College Ex-Students' Club. All rights reserved.</p>
                    </div>
                </div>

                {/* Right Side Illustration */}
                <div className="login-illustration">
                    <div className="illustration-content">
                        <img
                            src={logoMini}
                            alt="Alumni Illustration"
                            style={{ width: "150px" }}
                        />

                        {/* <h3>Welcome to Alumni Network</h3>
                        <p>Connect, collaborate, and grow with fellow alumni members</p>
                        <ul className="features-list">
                            <li><i className="fas fa-check"></i> Network with alumni</li>
                            <li><i className="fas fa-check"></i> Stay updated with events</li>
                            <li><i className="fas fa-check"></i> Share opportunities</li>
                            <li><i className="fas fa-check"></i> Build meaningful connections</li>
                        </ul> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
